import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CalendarComponent, FormatSettings } from '@progress/kendo-angular-dateinputs';
import { commonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-custom-calendar',
  templateUrl: './custom-calendar.component.html',
  styleUrl: './custom-calendar.component.scss'
})
export class CustomCalendarComponent {
  isRequiredDate = false;
  todayDate = this.commonService.resetDateTime(new Date());
  focusDate = this.todayDate;
  selectedValue!: Date | any;
  calDisable = false;
  disableCalender = false;


  @Input() set requiredDate(value: boolean) {
    this.isRequiredDate = value;
  }

  className = "";
  @Input() set inputCSS(value: string) {
    this.className = value;
  }

  @Input() set disableCalendar(value: boolean) {
    this.disableCalender = value;
  }

  @Input() set calendarDisabled(value: boolean) {
    this.calDisable = value;
  }

  @Input() set inputDate(value: any) {
    if (value) {
      let date = new Date(value);
      if (date.getFullYear() <= 1900) {
        this.selectedValue = null;
      }
      else {
        this.selectedValue = date;
        this.focusDate = date;
      }
    } else {
      this.selectedValue = null;
      this.focusDate = this.todayDate;
    }
  }

  @Output() selectedDate = new EventEmitter<Date>();

  constructor(private commonService: commonService, private el: ElementRef) { }
  private typingTimeout: any; // Timeout for debouncing
  onChange(event: any) {
    clearTimeout(this.typingTimeout); // Clear previous timeout
    this.typingTimeout = setTimeout(() => {
    this.selectedValue = event;
    // let date = new Date(event);
    // if (date.getFullYear() <= 1900 || date?.getFullYear() <= 1970) {
    //   this.selectedValue = null;
    // }

    this.selectedDate.emit(this.selectedValue);
  }, 5000); // Debounce delay (5000ms)
  }
}
